import { render, staticRenderFns } from "./SummaryActionData.vue?vue&type=template&id=2c0a9bf6&scoped=true"
import script from "./SummaryActionData.vue?vue&type=script&lang=ts"
export * from "./SummaryActionData.vue?vue&type=script&lang=ts"
import style0 from "./SummaryActionData.vue?vue&type=style&index=0&id=2c0a9bf6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0a9bf6",
  null
  
)

export default component.exports